import { AnyAction } from "redux";
import { action } from "typesafe-actions";
import { IBankfund24Data } from "./bankfund24.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { api } from "../../api/api";
import {
    showMessage,
} from "../messages/messagesActions";

// List actions
export const FETCH_BANKFUND24_DATA_PROGRESS = "FETCH_BANKFUND24_DATA_PROGRESS";
export const FETCH_BANKFUND24_DATA_SUCCESS = "FETCH_BANKFUND24_DATA_SUCCESS";
export const FETCH_BANKFUND24_DATA_FAILURE = "FETCH_BANKFUND24_DATA_FAILURE";

export const fetchBankfund24DataProgress = () => action(FETCH_BANKFUND24_DATA_PROGRESS);

export const fetchBankfund24DataSuccess = (
    data: IBankfund24Data[],
    totalRecords: number
) => action(FETCH_BANKFUND24_DATA_SUCCESS, { data, totalRecords });

export const fetchBankfund24DataFailure = (error: string) =>
    action(FETCH_BANKFUND24_DATA_FAILURE, error);

export const fetchBankfund24DataAsync =
    (
        forReport: boolean = false,
        query: {
            phone?: string,
            loan_type?: string,
            status?: string,
            pageNo?: number,
            itemsPerPage?: number,
            from_date?: string,
            to_date?: string,
        }
    ): ThunkAction<Promise<IBankfund24Data[] | void>, IStoreState, {}, AnyAction> =>
        async (dispatch) => {
            try {
                dispatch(fetchBankfund24DataProgress());
                let url = "";
                if(forReport === false){
                    url += `pageNo=${query.pageNo}&itemsPerPage=${query.itemsPerPage}&`;
                }
                if (query.phone) url += `phone=${query.phone}&`;
                if (query.loan_type) url += `loan_type=${query.loan_type}&`;
                if (query.status) url += `status=${query.status}&`;
                if (query.pageNo !== undefined) url += `pageNo=${query.pageNo}&`;
                if (query.itemsPerPage !== undefined) url += `itemsPerPage=${query.itemsPerPage}&`;
                if (query.from_date) url += `from_date=${query.from_date}&`;
                if (query.to_date) url += `to_date=${query.to_date}&`;
                const res = await api.get(`get-free-quote-bankfund24?${url}`);
                const data: IBankfund24Data[] = res.data.result;
                const totalRecords = res.data.totalRecords;

                if(forReport){
                    return data;
                }

                dispatch(
                    showMessage({
                        message: "Bankfund24 Data fetched successfully",
                        type: "success",
                        displayAs: "snackbar",
                    })
                );
                dispatch(fetchBankfund24DataSuccess(data, totalRecords));
            } catch (error: any) {
                dispatch(fetchBankfund24DataFailure(error.message));
                dispatch(
                    showMessage({
                        message: error.response?.data?.message || error.message,
                        type: "error",
                        displayAs: "snackbar",
                    })
                );
            }
        };

// Single record actions
export const FETCH_SINGLE_BANKFUND24_DATA_PROGRESS = "FETCH_SINGLE_BANKFUND24_DATA_PROGRESS";
export const FETCH_SINGLE_BANKFUND24_DATA_SUCCESS = "FETCH_SINGLE_BANKFUND24_DATA_SUCCESS";
export const FETCH_SINGLE_BANKFUND24_DATA_FAILURE = "FETCH_SINGLE_BANKFUND24_DATA_FAILURE";

export const fetchSingleBankfund24DataProgress = () =>
    action(FETCH_SINGLE_BANKFUND24_DATA_PROGRESS);

export const fetchSingleBankfund24DataSuccess = (data: IBankfund24Data) =>
    action(FETCH_SINGLE_BANKFUND24_DATA_SUCCESS, data);

export const fetchSingleBankfund24DataFailure = (error: string) =>
    action(FETCH_SINGLE_BANKFUND24_DATA_FAILURE, error);

export const fetchSingleBankfund24DataAsync =
    (id: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
        async (dispatch) => {
            try {
                dispatch(fetchSingleBankfund24DataProgress());
                const res = await api.get(`get-api-get-free-quote-bankfund24/${id}`);
                const data: IBankfund24Data = res.data.result;
                dispatch(
                    showMessage({
                        message: "Bankfund24 Data fetched successfully",
                        type: "success",
                        displayAs: "snackbar",
                    })
                );
                dispatch(fetchSingleBankfund24DataSuccess(data));
            } catch (error: any) {
                dispatch(fetchSingleBankfund24DataFailure(error.message));
                dispatch(
                    showMessage({
                        message: error.response?.data?.message || error.message,
                        type: "error",
                        displayAs: "snackbar",
                    })
                );
            }
        };

export const CLEAR_BANKFUND24_DATA = "CLEAR_BANKFUND24_DATA";
export const CLEAR_BANKFUND24_DATA_STATE = "CLEAR_BANKFUND24_DATA_STATE";
export const clearBankfund24Data = () => action(CLEAR_BANKFUND24_DATA);
export const clearBankfund24DataState = () => action(CLEAR_BANKFUND24_DATA_STATE); 